import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from "../../_services/authentication.service";
import {data} from "jquery";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  pwd: string;
  cpwd: string;
  token: string;
  environment = environment;

  constructor(
    private authsvc: AuthenticationService,
    private toastService: ToastrService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.params.subscribe(data => {
      this.token= data['token'];
    });
  }

  Reset() {
    if(this.pwd?.length >0 && this.cpwd?.length >0 && this.cpwd == this.pwd)
      this.authsvc.resetpwd({
        t: this.token,
        password : this.pwd,
        password_confirmation : this.cpwd
      }).subscribe(data=> {
        this.toastService.success("Password Modificata")
        this.router.navigate(["/Login"]);
      })
    else
      this.toastService.info("Inserire tutti i campi");
  }
}
